import useScrollAnimation from '../../../hooks/useScrollAnimation';

const painPoints = [
  {
    icon: 'ri-book-open-line',
    color: 'red',
    borderColor: 'border-red-400',
    bgColor: 'bg-red-50',
    iconColor: 'text-red-500',
    title: '¿Sigues anotando ventas en un cuaderno que luego nadie revisa?',
    desc: 'Ese cuaderno se llena, se pierde o simplemente nadie lo entiende. La información clave de tu negocio desaparece junto con él.',
    delay: 'anim-fade-up-1',
  },
  {
    icon: 'ri-error-warning-line',
    color: 'amber',
    borderColor: 'border-amber-400',
    bgColor: 'bg-amber-50',
    iconColor: 'text-amber-500',
    title: '¿Te das cuenta de que falta un producto justo cuando el cliente te lo pide?',
    desc: 'El peor momento para descubrir que no tienes stock es frente al cliente. Esa venta ya se perdió, y también su confianza.',
    delay: 'anim-fade-up-2',
  },
  {
    icon: 'ri-file-excel-line',
    color: 'orange',
    borderColor: 'border-orange-400',
    bgColor: 'bg-orange-50',
    iconColor: 'text-orange-500',
    title: '¿Pierdes horas frente a un Excel complejo que termina desactualizado?',
    desc: 'Fórmulas rotas, datos incorrectos, versiones duplicadas. El Excel era para ayudarte, pero terminó siendo otro problema más.',
    delay: 'anim-fade-up-3',
  },
];

const ProblemaSection = () => {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="problema" className="py-16 sm:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div ref={ref} className={`text-center mb-10 sm:mb-16 ${visible ? 'anim-fade-up' : 'scroll-hidden'}`}>
          <span className="inline-block bg-red-50 text-red-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            El Problema
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-black text-gray-900 leading-tight mb-4" style={{ fontFamily: "'Syne', sans-serif" }}>
            ¿Tu inventario es un <span className="text-red-500">caos</span> o una{' '}
            <span className="text-emerald-600">herramienta de ventas</span>?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-14">
          {painPoints.map((p) => (
            <div
              key={p.title}
              className={`group bg-white rounded-2xl border-l-4 ${p.borderColor} border border-gray-100 p-5 sm:p-7 hover:scale-[1.02] transition-transform cursor-default ${visible ? p.delay : 'scroll-hidden'}`}
            >
              <div className={`w-11 h-11 flex items-center justify-center ${p.bgColor} rounded-xl mb-4`}>
                <i className={`${p.icon} text-xl ${p.iconColor}`} />
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">{p.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Closing banner */}
        <div className={`bg-gray-900 rounded-2xl px-5 sm:px-8 py-6 sm:py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 ${visible ? 'anim-fade-up-4' : 'scroll-hidden'}`}>
          <div className="flex items-start sm:items-center gap-3 sm:gap-4">
            <div className="w-11 h-11 flex items-center justify-center bg-red-500 rounded-xl flex-shrink-0">
              <i className="ri-alert-line text-white text-xl" />
            </div>
            <p className="text-white text-sm sm:text-lg font-semibold leading-snug">
              El <span className="text-red-400 font-bold">desorden</span> te está costando clientes.{' '}
              <span className="text-gray-300 font-normal">Es hora de digitalizar tu bodega hoy mismo.</span>
            </p>
          </div>
          <button
            onClick={() => document.getElementById('solucion')?.scrollIntoView({ behavior: 'smooth' })}
            className="flex-shrink-0 bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-sm px-5 sm:px-6 py-3 rounded-xl transition-colors cursor-pointer w-full sm:w-auto text-center"
          >
            Ver la solución <i className="ri-arrow-down-line ml-1" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProblemaSection;
